export default function getVariant(productObj, options) {
  let count = 0;

  const optionObj = Object.values(options);
  for (let i = 0; i < optionObj.length; i += 1) {
    const value = optionObj[i];
    if (value !== "") {
      count += 1;
    }
  }

  let variantObj: VariantObj | null = null;
  for (let i = 0; i < productObj.variants.length; i += 1) {
    const variant = productObj.variants[i];

    switch (count) {
      case 1:
        if (variant.option1 === options.option1) {
          variantObj = variant;
        }
        break;
      case 2:
        if (
          variant.option1 === options.option1 &&
          variant.option2 === options.option2
        ) {
          variantObj = variant;
        }

        break;
      case 3:
        if (
          variant.option1 === options.option1 &&
          variant.option2 === options.option2 &&
          variant.option3 === options.option3
        ) {
          variantObj = variant;
        }
        break;
      default:
        variantObj = variant;
        break;
    }
  }
  if (variantObj) {
    return variantObj;
  }
  return null;
}
